export default __webpack_public_path__ + "static/media/path3.3f66cc18.png";